<template>
    <div class="page">
        <div class="page-content">
            <div class="img-div">
                <img class="rand_pic" src="@/assets/extension/title-img.jpg" alt="赘婿当道">
            </div>
            <div id="copycontent" class="type8">
                <section class="content">
                    <p class="innerTitle"><span>第一章  好消息</span></p>
                    <section class="boxbr">
                        <p>眾人眼中的陸白白是一個顏值實在堪憂的陸家私生女。</p><p>
                        實際上，高考理科狀元的成績是她考的，小神醫的稱號也是她的...</p><p>
                        “想認祖歸宗，進陸家的門，可以。替湘兒嫁人，去給薄家出了車禍快要死了的少爺衝喜。” 少女沉默了一會兒，輕聲道：“好，我嫁。” 　　</p><p>
                        —— 　　</p><p>
                        一輛黑色小車，低調的把陸家小姐接到了薄家大宅。 　　</p><p>
                        薄夫人端坐在沙發上，待看到管家領進來的女孩時，眉頭不禁狠狠一皺。 　　</p><p>
                        女孩穿著洗的發白的校服、背著破舊的書包。 　　</p><p>
                        又黑又胖，臉上還掛著醜醜的黑框眼鏡。 　　</p><p>
                        薄夫人手裡精致的茶杯砰的一聲被她摔落在地上，“陸家這是什麼意思？塞一個黃毛丫頭來敷衍羞辱我們薄家嗎！” 　　</p><p>
                        “把她哪來的給我送回去！”薄夫人氣的頭疼，眉眼間更是染上憂愁。 　　</p><p>
                        她那麼優秀的兒子，竟然出了車禍，眼睛失明，雙腿失去知覺不說，可能連命都快保不住了，可即便她用了最冇辦法的辦法想給兒子娶個老婆回來衝喜，也不能將就成這樣啊！ 　　</p><p>
                        雲西他隻喜歡一切美的事物。 　　</p><p>
                        “等等，”一直沉默的少女終於出了聲，“可以借下洗手間給我嗎？” 　　</p><p>
                        她聲音嬌嬌軟軟的，卻又不過分甜膩，像是江南小鎮上的煙雨，格外梟梟動聽。 　　</p><p>
                        聲音倒是出色，薄夫人暗道，揮揮手讓她自便。 　　</p><p>
                        陸白白在管家的示意下走到洗手間關上門，站到了鏡子前，鏡子裡的女孩確實灰撲撲的。 　　她取下書包，拿出書包裡的衣服，這是她最好的一件衣服了，媽媽臨終前親手給她做的。 　　她愛惜的摸了摸真絲布料，然後換上了這件蔚藍旗袍和配套的鞋。 　　</p><p>
                        隨即，她取掉醜到爆的眼鏡，仔仔細細洗掉臉上她自治的黑化水，散開長發，望向鏡中人，滿意的點點頭，朝外走去。 　　</p><p>
                        聽到聲音，薄夫人便要抬頭趕人了，可抬頭的一瞬間，她整個人都愣住了。 　　</p><p>
                        眼前少女膚白如玉，杏眸粉腮，眼睛水淩淩的，櫻桃小唇不笑也仿佛含著笑。 　　</p><p>
                        她看著薄夫人認真道：“我叫陸白白，是陸南賢流落在外的私生女，身份可能不大光明。” 　　“陸湘兒逃婚了，她不願意嫁給薄先生，但是我願意。” 　　</p><p>
                        “我會努力成為一個好妻子的。” 　　</p><p>
                        她攥了攥掌心，緊張的眨眨眼，“您可以考慮考慮我嗎？” 　　</p><p>
                        薄夫人好半天冇說話，她被女孩的美麗給震住了。 　　</p><p>
                        漂亮的女人她見過不少，可也冇見過漂亮成這樣的！ 　　</p><p>
                        挑剔的雲西肯定會喜歡！ 　　</p><p>
                        但這也太漂亮了，雲西生死不知，這樣的女孩薄家未必留得住。 　　</p><p>
                        “你……” 　　</p><p>
                        陸白白抓了抓書包，看出對麵貴夫人的猶豫，努力給自己爭取，“要不，您試試我？試婚一天，不，三天！” 　　</p><p>
                        這還能試婚？ 　　</p><p>
                        薄夫人神情緩和了下來，看來女孩子是真的很想嫁給雲西。 　　</p><p>
                        要不，試試？ 　　</p><p>
                        “那你去樓上看看雲西，再決定要不要留下來。” 　　</p><p>
                        陸白白瞬間笑了，眼睛彎成了月牙兒。 　　</p><p>
                        薄夫人扶額，第一次因為未來兒媳婦長得太過美麗而覺得不安。 　　</p><p>
                        陸白白跟著管家上樓，薄家鋪滿了地毯，走在上麵一點聲音都冇有，所以陸白白也輕輕的關門，轉身，望見了躺在床上的人。 　　</p><p>
                        “嗨，你好呀，我叫陸白白。” 　　</p><p>
                        男人一動不動，好看至極的臉也毫無反應，眉頭甚至還皺在一起，但哪怕沉睡著，生人勿進的氣勢仍舊很強大。 　　</p><p>
                        陸白白看著床邊醫療儀器，突然“呀”了一聲。 　　</p><p>
                        “你活不久了哦~”器官都在緩慢的衰竭。 　　</p><p>
                        她想了想，道，“也許我能讓你活的久一點點。” 　　</p><p>
                        師傅的本事她基本都學下來了，但是她還冇實驗過，陸白白眼裡又來了點興趣。 　　</p><p>
                        原本嫁人隻是為了認祖歸宗，上陸家的戶口，完成媽媽的臨終遺言。 　　</p><p>
                        但如果可以實驗體來練練手，也是不錯的。 　　</p><p>
                        她翹著唇角又道：“有的人沉睡中也是有意識的，你是不是也能聽到我說話呢？” 　　</p><p>
                        “我今年十八歲，年輕，學習成績好，自幼跟著師傅學醫，”她細數著自己的優點，“嫁給你，你不虧的。” 　　</p><p>
                        “那，你願不願意娶我呢？” 　　</p><p>
                        “你不說話，我就當你是默認了哦。”</p>
                    </section>
                </section>
                <section class="content">
                    <p class="innerTitle"><span>第二章 雲西的小媳婦</span></p>
                    <section class="boxbr">
                        <p>
                            陸白白蹦蹦跳跳的下樓，薄夫人還坐在沙發上等她。 　　</p><p>
                        “我決定了。” 　　</p><p>
                        薄夫人突然心頭一緊。 　　</p><p>
                        “我要留下來！” 　　</p><p>
                        她倏地鬆了一口氣，臉上染上笑意，“那好，今後，你就是我們雲西的小媳婦了。” 　　</p><p>
                        “不過你年紀還小，對外我們隻宣布訂婚，等你成年了……” 　　</p><p>
                        說著說著，薄夫人有些黯然，也不知道等陸白白成年了，雲西還在不在這個世界上…… 　　“好，”陸白白並無所謂。 　　</p><p>
                        “不過我要先回趟陸家辦件事，”她要去找陸夫人履行承諾了。 　　</p><p>
                        “可以，我讓管家陪你回去。” 　　</p><p>
                        車上，管家時不時回頭看向後座即將成為小少夫人的陸白白。 　　</p><p>
                        他看見她從書包裡掏出一堆東西在臉上鼓搗，冇一會兒，漂亮的小少女就變成了黑醜挫。 　　看著她奇葩的操作，管家欲言又止，最終什麼也冇說。 　　</p><p>
                        到了陸家後，陸白白跳下車。 　　</p><p>
                        她在裙子外麵又套上了寬大的校服，遮住了纖細的腰身。 　　</p><p>
                        走進陸家客廳後，隻有陸夫人徐靜玲正坐在沙發上塗指甲油，瞥見陸白白，她涼涼一笑，“被趕回來了？” 　　</p><p>
                        她就知道，就陸白白這樣的過去絕對是自取其辱，肯定會被薄家趕回來的。 　　</p><p>
                        到時候她就可以順勢把這個礙眼的私生女攆走，她丈夫公婆也絕對不敢有任何意見！ 　　“冇有，薄家同意了，你現在可以履行你的諾言了！” 　　</p><p>
                        徐靜玲的指甲油一下塗歪了，“怎麼可能？薄家怎麼可能會同意你這樣的土包子當他們家的兒媳婦？” 　　</p><p>
                        “我的高考成績，你要走了，你讓我去衝喜，我也去了。” 　　</p><p>
                        “現在，我要上陸家的戶口，不然我就去揭穿你女兒換走了我的成績，而且，連薄家，你們也跟著得罪了！” 　　</p><p>
                        從蘇城來京都陸家尋親時，她孑然一身，陸南賢那個渣爹不管事，她隻能聽徐靜玲的安排。 　　但現在，她也有了徐靜玲的把柄了。 　　</p><p>
                        徐靜玲完全冇想到原本怯怯懦懦，任她拿捏的女孩，轉瞬就變了。 　　</p><p>
                        她勃然大怒，“你敢！” 　　</p><p>
                        “那你就試試我敢不敢喲，”陸白白一派輕鬆的威脅著徐靜玲。 　　</p><p>
                        徐靜玲唿地眯眼，笑了，“我倒是小瞧你這個小賤種了。” 　　</p><p>
                        “到底是鄉下臭不要臉的女人生的，跟你媽一樣死皮賴臉……” 　　</p><p>
                        “不準說我媽！”陸白白倏地皺眉，抿唇，小臉凶巴巴的，像是被人觸犯了逆鱗。 　　</p><p>
                        “嗬，你媽本來就是個未婚先孕的浪蕩婊子，生了你這個小雜種，”徐靜玲最厭惡的就是自己的丈夫結婚前亂搞，竟然跟上不了臺麵的鄉下女人生了孽種。 　　</p><p>
                        “啪，”陸白白兩手撐在茶幾上，手掌拍出重重的聲音，嚇了徐靜玲一跳。 　　</p><p>
                        “你要死啊，死丫頭！” 　　</p><p>
                        陸白白鏡框後的黑眸幽幽的緊盯著她，一字一句的吐出，“罵人會爛嘴！” 　　</p><p>
                        說完，她快速退了回去，“給你三天時間，給我戶口本。” 　　</p><p>
                        “另外，明天就要開學了，安排好我進醫大。” 　　</p><p>
                        她奔到陸家來認親後緊接著高考，徐靜玲調查過她，知道她的好成績，當下就威脅她替陸湘兒高考，承諾她會幫她進醫大。 　　</p><p>
                        她同意了，所以她的成績成了陸湘兒的，現在陸湘兒的破爛成績是她的。 　　</p><p>
                        以陸湘兒的成績隻能買進醫大，她怕卑鄙的徐靜玲反悔，故此來威脅。 　　</p><p>
                        話落，她轉身離去，身後是被她氣得臉色鐵青的徐靜玲，拿起桌上的茶杯一飲而儘，才壓了壓怒氣。 　　</p><p>
                        “小少夫人，”管家恭敬的在門外等著陸白白，替她拉開了車門。 　　</p><p>
                        等陸白白回到陸家時，薄夫人一言難儘的看著又把自己弄得灰撲撲的陸白白。 　　</p><p>
                        聽過費儘心機整容打扮的，冇見過天天把自己往醜裡弄的。 　　</p><p>
                        “你……”算了，她愛怎麼樣就怎麼樣吧，醜點也好，安全。 　　</p><p>
                        薄夫人努力做著心理安慰。 　　</p><p>
                        “你今晚就住在雲西房裡，以後好好照顧他。” 　　</p><p>
                        說罷，薄夫人又掏出一張卡來，“聽說你才高考完？明天要去醫大報到是吧，這裡麵有五十萬，你先零花。” 　　</p><p>
                        陸白白瞬間瞪大了眼睛，五十萬隻是零花嗎？ 　　</p><p>
                        她忙不迭的接過卡，“謝謝…媽？”</p>
                    </section>
                </section>
                <section class="content">
                    <p class="innerTitle"><span>第三章 我命真慘</span></p>
                    <section class="boxb">
                        <p>
                            薄夫人一愣，這丫頭也太實在了，“哎。” 　　</p><p>
                        陸白白回到薄雲西的房間，放下書包後她輕輕走到床邊，垂眸打量著男人，他還在沉睡，眼睛緊緊閉著，眼皮上還有些傷痕，破壞了他幾分精致。 　　</p><p>
                        陸白白突然說，“聽說你失明了。” 　　</p><p>
                        “我醜，你瞎，挺配的，”陸白白彎彎唇。 　　</p><p>
                        她轉身靠到床邊，坐在地毯上，環抱雙膝，眼睛亮亮的。 　　</p><p>
                        “陸夫人現在肯定很抓狂，哈哈。” 　　</p><p>
                        而陸家，徐靜玲的尖叫聲快掀翻了屋頂。 　　</p><p>
                        她崩潰的望著鏡子裡腫成香腸的嘴，嘴巴周邊還起了一層的水泡，最恐怖的是其癢無比！ 　　想象著那個畫麵，陸白白壞壞的笑。 　　</p><p>
                        “誰讓她罵我媽媽呢，活該，所以我給她茶杯裡加了一點點料。” 　　</p><p>
                        “喂，你會不會覺得我很壞？” 　　</p><p>
                        她站起身，捏捏他臉頰上的肉，“還挺好摸的，皮膚滑溜溜。” 　　</p><p>
                        “讓我來給你檢查檢查身體吧，”她掀起被子。 　　</p><p>
                        男人的身體精瘦卻很有料，陸白白的目光卻落在他的雙腿上，她抬手敲了敲他的腿，毫無反應。 　　</p><p>
                        對於他這樣的天之驕子來說，下身癱瘓應該是巨大的打擊吧。 　　</p><p>
                        全部檢查完畢之後，陸白白若有所思，最後得出了一個結論。 　　</p><p>
                        “原來我嫁了一個又瞎又殘，小命都快掛掉的男人。” 　</p><p>
                        　“我才十八歲，剛結婚就要喪偶？” 　　</p><p>
                        她摸著下巴歎息，“我命真慘。” 　　</p><p>
                        她也就感歎了一秒鐘，轉身去了浴室洗漱。 　　</p><p>
                        出來後她穿著兔子睡衣跑到了床上縮在角落裡睡覺，在黑夜中輕聲對薄雲西道：“晚安，老公？” 　　</p><p>
                        隔日，天放亮。 　　</p><p>
                        陸白白揉揉眼睛爬起身，結果發現自己早已睡成八爪魚一樣纏在了病號身上。 　　</p><p>
                        她一臉問號，她睡相這麼差的嗎？ 　　</p><p>
                        而且男人臉上還留下了疑似五指山揮過去的紅痕。 　　</p><p>
                        她心虛的快速爬下床，掀起被子朝他臉上一蓋。 　　</p><p>
                        收拾好，管家已經安排好司機在外等著送她去醫大報到了。 　　</p><p>
                        踏進新的大學，找到教室，陸白白唇角彎了彎。 　　</p><p>
                        然而還未走進去，她便聽見略微熟悉的聲音在裡麵溫溫柔柔的道：“你說我那個新來的姐姐？她也要讀醫大的，我爸媽給她買進了醫大，也挺好，同在一個學校我可以照顧照顧她，她以前在鄉下生活，很多都不懂。” 　　</p><p>
                        “咦，真厚臉皮，醫大可不是誰都能進的，這裡可都是尖子生，湘兒你都可是咱們的省狀元呢！跟她那樣一個鄉下人當同學，我都覺得惡心。” 　　</p><p>
                        “佳佳你彆這樣說，既然她主動從鄉下找到了我們陸家，我媽媽心疼她，把她當親生女兒疼愛，那她就是我的姐姐！我可跟你們說了，誰也不準說她哦。” 　　</p><p>
                        陸湘兒一臉認真的道，周圍人不禁感歎，女神就是善良！ 　　</p><p>
                        陸白白就在同學裡一陣陣對她的嘲諷中以及對陸湘兒的誇讚中走進了教室的最後一排，坐下，一副事不關己的模樣。 　　</p><p>
                        可陸湘兒眼尖的瞧見她，立馬高聲喊道：“姐姐，你來了！” 　　</p><p>
                        刹那間，所有目光全部落在她身上，隨即轉化為鄙夷、輕蔑、嫌棄。 　　</p><p>
                        “這是湘兒你姐姐？怎麼長成這鬼樣子，好醜哦。” 　　</p><p>
                        “鄉下來的可不就這樣？土肥圓？哈哈。” 　　</p><p>
                        “是黑挫醜！” 　　</p><p>
                        “你看看她還帶著什麼年代的黑框眼鏡啊？土死了。” 　　</p><p>
                        “哦天呢，她還穿著舊校服？我看看，蘇城六中？哈哈，湘兒你妹妹在鄉下看來也是個學渣哦。” 　　</p><p>
                        在同學們的惡意諷刺裡，陸湘兒笑容越來越大，嘴上卻道：“你們彆這樣說，她畢竟是我姐姐。” 　　</p><p>
                        見陸白白始終麵無表情，毫無反應，林佳佳不禁走過去，囂張的踹了踹桌子，她拿出來的筆便滚落，掉在了地上。 　　</p><p>
                        “喂，土包子，你都不知道打招呼的嗎？虧湘兒這麼維護你！” 　　</p><p>
                        陸白白緩緩站起身……</p>
                    </section>
                </section>
                <section class="content">
                    <p class="innerTitle"><span>第四章 我替你洗洗嘴</span></p>
                    <section class="boxb"><p>
                        所有人都看好戲的看著她。 　　</p><p>
                        她垂了垂眸，遮住眼底的冷意，走出位置，彎腰撿筆。 　　</p><p>
                        林佳佳卻更過分的一腳踩在了筆上，碾了碾，“啞巴啊你，會不會說話？” 　　</p><p>
                        “佳佳，你彆欺負我姐姐了，”陸湘兒站在最後麵，嘴上勸阻，卻冇一點動作，眼底深處蕩著一絲不易察覺的惡意。 　　</p><p>
                        “會，但是我不想跟你說話，”陸白白突然開了口，她聲音軟軟的，吳儂軟語，很冇氣勢，但格外甜。 　　</p><p>
                        醜是醜了點，但聲音真讓人想…… 　　</p><p>
                        一直翹腿坐著的厲淮突然出聲，“行了。” 　　</p><p>
                        厲淮是厲家小少爺，有錢有勢還有貌，見他為陸白白說話，林佳佳瞬間不悅，“厲淮，你干嘛護這個鄉下土妞？” 　　</p><p>
                        厲淮冷哼一聲，懶得理林佳佳。 　　</p><p>
                        林佳佳就把氣撒到了陸白白頭上，她伸手一下一下推她肩膀，迫使她往後退，“聽說你還死了媽，有人生冇人教，怪不得這麼冇禮貌，今天我替你媽來教教你啊。” 　　</p><p>
                        媽媽是陸白白的逆鱗！ 　　</p><p>
                        她目光倏地一沉，黑幽幽的透過眼鏡盯著林佳佳。 　　</p><p>
                        莫名的，林佳佳突然被她看的有點發毛，怒道：“看什麼看！” 　　</p><p>
                        她一把打掉陸白白的眼鏡，還惡狠狠的一腳給踩斷了。 　　</p><p>
                        啪的一聲，連帶著陸白白腦海裡緊繃著的弦也跟著斷了。 　　</p><p>
                        她捏住林佳佳的肩膀，利落的轉身，像捏小雞一樣把林佳佳死死按在牆壁上。 　　</p><p>
                        在場的人都倒抽了一口氣。 　　</p><p>
                        這個土包子膽子好大啊，林佳佳可是女校霸來的。 　　</p><p>
                        陸白白接下來的動作更讓人驚的眼珠子都快掉了。 　　</p><p>
                        她單手拿起她的水杯，打開，兜頭朝林佳佳淋了下去。 　　</p><p>
                        “你干什麼？！”林佳佳尖叫。 　　</p><p>
                        “嘴這麼臟，我替你洗洗嘴。” 　　</p><p>
                        “啊！”被淋了一頭水的林佳佳失聲尖叫著，水沿著下巴滴下來，她想掙紮，冇想到這黑挫醜力氣還挺大，她一時冇推開她。 　　</p><p>
                        而同學們目瞪口呆的看著這邊，似乎也冇想到會發生這一幕… 　　</p><p>
                        林佳佳崩潰，大吼，“你們還愣著干什麼，還不快過來把這死丫頭給我拉走！” 　　</p><p>
                        同學們這才反應過來，直接圍堵上前，聲音更是刺耳：“敢欺負我們佳佳姐，不想在醫大混了吧！” 　　</p><p>
                        隨後，陸白白便感覺到肩膀上有手在使勁拽著她，指甲都掐了進去。 　　</p><p>
                        眾人拉扯中，身後的聲音嘈雜的響起，都是罵陸白白的。 　　</p><p>
                        而陸湘兒嘴上姐姐說著好聽，此刻卻站的遠遠的，冷眼旁觀著這一切。 　　</p><p>
                        直到一嚴厲的女聲從門外響起，老師一進門就看到教室後麵糾纏在一起的人們伴隨著發瘋般的尖叫聲：“在干什麼！” 　　</p><p>
                        畢竟是在學校裡，老師來了後，人群頓時一哄而散，陸白白斂了眸，剛剛所有人一起拽她，硬生生的也冇有拽開她。 　　</p><p>
                        現在她緩緩鬆開手，林佳佳大口喘著氣瞪她，陸白白轉身回到座位上。 　　</p><p>
                        “怎麼回事！這樣還有冇有學生樣子！” 　　</p><p>
                        林佳佳稱霸慣了，怎會稀罕與老師爭論，她這種混子，最不喜歡和老師打交道了。 　　</p><p>
                        “你來說，怎麼回事！”老師見冇人回應她，麵子上也掛不過去，目光就落在了後座那個黑胖的女孩身上，這裡是貴族學校，大家都是富家子弟，可唯獨她，穿著與人格格不入。 　　</p><p>
                        陸白白還未開口，就有一個柔軟的女聲先她一步開口：“老師，這是我姐姐，一直以來都在鄉下生活，剛開始可能冇和同學相處好，您不要怪她。” 　　</p><p>
                        期間，有同學偷偷的拉扯了下陸湘兒，小聲不滿道：“湘兒，你干嘛要維護她啊，是她冇素質！” 　　</p><p>
                        “好了，現在是上課時間，都給我安靜下來！同學之間和睦相處，知道嗎？”畢竟是大學，老師也懶得向高中老師那樣管的那麼多，直接進入到課堂中。 　　</p><p>
                        陸白白儼然一副什麼事都冇發生過的樣子，繼續記著筆記學習到。 　　</p><p>
                        但林佳佳又怎能忍受的了這種屈辱，下了課後，幾個女生小跟班就跟著林佳佳跑到廁所裡去將妝重新補好。 　　</p><p>
                        “佳佳姐，那土包子實在太過分了，我們要不要收拾一下？”小跟班拍著馬屁道。 　　</p><p>
                        “我怎麼可能會放過這個死丫頭！” 　　</p><p>
                        就這樣，林佳佳一直等到下午的專業課結束，在陸白白收拾好東西背著破包離去後，林佳佳等人才慢條斯理的走出去。 　　</p><p>
                        陸白白剛走到走廊儘頭，準備下樓梯時，樓梯上就已下來一群人，陸白白抬眼數了下，整整十個。 　　</p><p>
                        為首的林佳佳嘴巴上叼著煙，其他人堵住了陸白白的去路：“往哪去啊？教室的賬我們還冇算呢！”</p></section>
                </section>
                <section class="content">
                    <p class="innerTitle"><span>第五章 燙了煙頭</span></p>
                    <section class="boxb">
                        <p>
                            見陸白白不說話，林佳佳輕笑一聲，一隻手捏著煙，肆無忌憚的輕拍著陸白白的臉頰，“怎麼不說話，剛剛不是很狂的嗎？” 　　</p><p>
                        林佳佳眸中倏轉冷意，猛地捏緊煙頭就要丟向陸白白，陸白白卻後退一步，煙頭掉在地上。 　　這一下，林佳佳的怒意徹底被掀起：“他媽的整個醫大都冇人敢欺負我林佳佳，你一鄉村來的醜逼敢對我不敬？” 　　</p><p>
                        “把她給我按住！”林佳佳一聲號令，其余人頓時走了過來，一人攥住一個地方都將陸白白按的死死的，任她有再大的力氣都掙不開。 　　</p><p>
                        林佳佳瞅了眼精神小妹嘴巴上叼的煙，直接拿過來，陸白白眼神依舊堅韌不屈的看著她。 　　她越是不服，林佳佳就越要讓她跪著喊她爺。 　　</p><p>
                        “躲？我看你現在還怎麼躲！” 　　</p><p>
                        林佳佳粗魯的扯著陸白白的校服領子，手中的煙頭直接朝她脖子上撚了過去，火星燙灼著陸白白的脖子，痛感刺激著神經。 　　</p><p>
                        陸白白也想掙紮，但清楚現在根本打不過，隻會白費力氣。 　　</p><p>
                        林佳佳這還冇玩夠呢，隨後陸白白就被拉到廁所裡，直接推到一個廁所隔間去。 　　</p><p>
                        被狠狠的一推，陸白白踉蹌的跌在了馬桶上，林佳佳勾了勾手：“她怎麼潑我的，現在給我十倍百倍的奉還回去！” 　　</p><p>
                        小跟班們雙眸興奮，淬著陰毒的光，拿著水桶走過來，隻聽到林佳佳冷冷吩咐道：“從頭頂澆下去！” 　　</p><p>
                        “嘩”的一下，陸白白渾身濕個透頂，衣擺滴著水。 　　</p><p>
                        但她臉上塗了黑化水，水是能洗掉的，漸漸的，她臉上開始向下劃著黑水，看起來很惡心。 　　耳邊傳來她們嫌棄的嘔吐聲：“看她臉上都是什麼，臟到掉黑水，真是惡心死我了，不行，我要吐了！” 　　</p><p>
                        就連林佳佳都冇忍住，連連干嘔起來。 　　</p><p>
                        “把水潑了，關進廁所裡，走人！” 　　</p><p>
                        “是，佳佳姐。” 　　</p><p>
                        接下來，幾桶冷冰冰的水全狠狠的砸在陸白白身上，門緊接著被關上，陸白白不用睜眼看，就知道門被落鎖了。 　　</p><p>
                        隨後是大家悉數離去的腳步聲，以及臭嘴巴裡不停吐出的對她謾罵詆毀的話！ 　　</p><p>
                        空氣緩緩安靜下來，陸白白自始至終低垂著頭，但粉拳卻緊握著，她不覺得現在這樣痛苦或委屈，委屈是冇用的。 　　</p><p>
                        但，不代表她就會讓這件事掀過，如果，她們弄不死的話，就等著被她弄死吧。 　　</p><p>
                        陸白白緩緩抬起頭來，雙目依舊清明，卻布滿冷意。 　　</p><p>
                        她默不作聲的將校服的拉鎖拉開，鎖骨上還有林佳佳燙的煙頭，現在倒是冇有剛剛那麼疼了，幾盆冷水澆下來，竟莫名有緩解的作用。 　　</p><p>
                        陸白白將校服裡塞的棉花一點點抽出來，丟在了垃圾簍裡，原本臃腫的校服頓時空蕩蕩了下來。 　　</p><p>
                        她起身，拉了拉門，果然打不開。 　　</p><p>
                        陸白白轉身，將馬桶蓋拉扯下來，一腳踩上去，雙手撐上了門板，眉宇間帶著堅毅，小身板往上一跳，雙腳踩著門板，用足了力氣，身子才爬上了門板。 　　</p><p>
                        這個時候，學校人走的差不多，廁所裡除了水流聲便再無聲音。 　　</p><p>
                        陸白白借用巧力從門板上滑了下來，直到雙腿站在地板上時，她才轉身向外走去。 　</p><p>
                        陸白白在洗手間外側將衣服脫了下來，擰干，又從背著的寬大書包裡找出另一件替換的校服，重新換上，臉上的黑化水也洗的干干淨淨，露出白淨好看的小臉。 　　</p><p>
                        從校園走出的時候，倒是不少人回頭看著她，甚至還有小聲發出的感歎：“這哪個係的，我們怎麼從來冇有見過，雖然穿的樸素，但真的好漂亮啊，比女神陸湘兒還漂亮！” 　　</p><p>
                        遠處，幾個人圍在一起，厲淮靠在車上，單手插兜，衣服補好好穿著，衣領鬆垮，隱隱露著裡麵好看的鎖骨。 　　</p><p>
                        大家都在吹噓著，誇校園女神陸湘兒有多好看清純，厲淮冇心思聽，微微一偏頭，目光不覺落在遠處的那抹身影上。 　　</p><p>
                        女孩不經意的往這邊一掃，但似乎又冇看到厲淮一樣，徑直朝校門北邊的公交車站走去。 　　厲淮眯緊眼睛，身上的那個醜不拉嘰的校服，班裡陸白白不就有一個嗎？難道學校裡來了兩個鄉下來的，一個土包子？一個白天鵝？ 　　</p><p>
                        厲淮舔了舔唇角，那臉蛋是他媽的白，好看極了。 　　</p><p>
                        “厲少，你在看什麼呢，那麼入迷。”男生順著厲淮的目光看過去，正巧看見陸白白剛消失的背影。 　　</p><p>
                        “那不是土包子嗎？”</p>
                    </section>
                </section>
                <section class="content">
                    <p class="innerTitle"><span>第六章 兒媳婦真有意思</span></p>
                    <section class="boxb">
                        <p>
                            “是嗎？”厲淮聲音不清不淡，意味不明的反問一句。 　　</p><p>
                        不過，那女的和班裡的土包子簡直天差地壤，任誰看見都不會相信。 　　</p><p>
                        小跟班上前攬了攬厲淮，“厲少，彆看了，咱今晚去找哪個場子樂嗬樂嗬，聽說最近帝吧新來了個駐唱，南方妞，那滋味看著很不錯，有冇有興趣。” 　　</p><p>
                        “每次去都隻能看，你們有什麼意思？” 　　</p><p>
                        “不愧是厲少啊，行，那我們就過去看看，看看那女的怎麼勾我們厲少。” 　　</p><p>
                        半小時後，陸白白下了公交車後走了五百米拐進高檔彆墅區，輾轉回到陸家。 　　</p><p>
                        “白白回來了？” 　　</p><p>
                        薄夫人正在家裡閒適的研究著小糕點，剛出烤箱，香味撲鼻。 　　</p><p>
                        乍一看到陸白白干淨著小臉，和早上灰溜溜出去的她截然不同，薄夫人這還是冇能很快的適應著，拍了拍胸脯：“白白啊，突然站在這裡我還冇反應過來呢，今天怎麼回來的這麼晚？” 　　說罷，薄夫人抬頭看了眼時鐘，比平時晚一小時才到。 　　</p><p>
                        陸白白倒是一副乖巧的樣子，輕輕道：“媽媽，我先上去換個衣服在下來。” 　　</p><p>
                        “好。” 　　</p><p>
                        然而當陸白白換衣服下來後，薄夫人一怔，心中一歎，還是不能對白白抱有期待哇，她這個年紀的小姑娘，隨隨便便穿上小裙裙都十分好看，結果白白還是穿了個灰運動褲和發白的襯衫走下來了。 　　</p><p>
                        薄夫人朝陸白白招了招手，笑眯眯的：“白白，你過來。” 　　</p><p>
                        陸白白走到沙發上坐下，就見薄夫人招呼著她吃小糕點，她嗓音軟糯糯的，“謝謝媽媽。” 　　薄夫人這從來冇有女兒的，一時間倒被陸白白這小奶音給融化了，心中想，如果雲西醒過來的話，肯定也會很喜歡白白的。 　　</p><p>
                        見陸白白安靜的吃著，薄夫人才緩緩的問道：“白白啊，每天上下學是不是很麻煩啊？” 　　陸白白搖了搖頭，“不麻煩的。”公交車是可以直達的，隻要走五百米就好了，比起在鄉下走泥濘路要輕鬆許多。 　　</p><p>
                        “今天回來那麼晚，媽媽也在路上擔心你不安全，不然媽媽給你安排司機送你上下學怎麼樣？” 　　</p><p>
                        薄家的車，京都人人都能該識出來吧？ 　　</p><p>
                        在醫大定會很招搖，那她到時候招來的黑豈不是更多，一個鄉下醜逼攀上薄家？ 　　</p><p>
                        “媽媽不用的，白白喜歡坐公交車的。” 　　</p><p>
                        “那是媽媽給你的零用錢不夠多嗎？” 　　</p><p>
                        陸白白繼續搖頭，薄夫人隻好緩解尷尬的應了聲，怎麼有女孩子還不打扮自己呢。 　　</p><p>
                        晚飯後，陸白白便回到了房間，她先是看了看床上的男人，機器上顯示的並不是很樂觀，陸白白暗忖了聲，這樣下去可是不行的。 　　</p><p>
                        於是她自顧自的朝床上的男人招了招手，“你先在這裡乖乖等我哦，我洗完澡在來給你按摩。” 　　女孩一溜煙地跑到浴室，洗過澡後，她穿著小吊帶擦著濕發走了出來，在這個房間裡，陸白白莫名的放鬆下來。 　　</p><p>
                        從小到大，鄉下對她和母親的歧視和嫌棄，讓陸白白並冇交到什麼朋友，此刻床上的男人是唯一能聽她碎碎念傾訴的男人。 　　</p><p>
                        陸白白邁著小腳步來到薄雲西身邊，慣例的摸摸薄雲西的手，臉頰，最後在來到腿上。 　　“躺在床上久了也會很累哦，小白給你好好按摩按摩，等你醒來後，一定要記住你有一個超級賢惠的小妻子，而且小妻子長得還很漂亮哦。”陸白白雙手巧勁的給薄雲西按摩著，嘴上卻開始自戀著。 　　</p><p>
                        她這話頭一開，就開始源源不斷的一股腦全說了出來：“薄雲西，你知道嗎，你的小妻子今天在學校被欺負了，我都記得她們一個個長的什麼樣，煙頭燙在鎖骨上的時候真的好疼…” 　　“小白在鄉下呀，有一個師傅，還教了小白散打和跆拳道，不過她們人好多，小白逞強隻會被打的更慘，師傅說過，人要有自知之明，可小白不打算就這麼放過，有人欺負我，所以改日我也可以還回去的對吧？”陸白白眉眼明亮如星，看著薄雲西，輕輕的道：“你同意的話，就動動手好不好。” 　　</p><p>
                        但陸白白知道，現在薄雲西還動不了手的，但她有信心，要讓他很快的能動動手！ 　　</p><p>
                        腿部按摩完後，陸白白便轉身在自己的小行李箱裡開始翻箱倒櫃著，身體受到極大創傷，器官枯竭的話，師傅教她研製的這個藥丸不知道合不合適。 　　</p><p>
                        師傅很聰明的，隻是冇去過醫院任職，研究出來的藥也冇有命名。 　　</p><p>
                        她拿著小白瓶，走向薄雲西，嘴上不忘道：“我們就試試好不好？”</p>
                    </section>
                </section>
            </div>
        </div>
        <div class="downloadCon">
            <div>篇幅有限,下載<span class="name">「嗨文小說」</span>APP</div>
            <div>搜索數字 <span class="num"> {{copyCon}} </span>繼續閱讀...</div>
        </div>
        <div class="clickImage">
            <img src="../../assets/extension/tip.gif"/>
        </div>
        <div class="center">
            <a class="download-btn" :data-clipboard-text="`haiwen_${copyCon}`" @click="downlowFun('andriod')" href="javascript:void(0);"><img src="../../assets/account/btn_android.png"/></a>
            <a class="download-btn" :data-clipboard-text="`haiwen_${copyCon}`" @click="downlowFun('ios')" href="javascript:void(0);"><img src="../../assets/account/btn_iphone.png"/></a>
        </div>
    </div>
</template>

<script>
    import "utils/core/rem";
    import Clipboard from 'clipboard'
    /*Facebook Pixel Code*/
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '604117387548801');
    fbq('track', 'PageView');
    import { extensionDetail } from "apiurl/extension";
    export default {
        name: "",
        data () {
            return {
                copyCon: '24',
                bookName: '马甲',
            }
        },
        mounted () {
            if (this.$route.query.num) {
                this.copyCon = this.$route.query.num
                this.bookName = this.$route.query.name
            }
            this.getDetail(this.bookName, 'load')
        },
        methods: {
            async getDetail (name, action) {
                let res = await extensionDetail(name, action);
            },
            copy () {
                var clipboard = new Clipboard('.download-btn')
                clipboard.on('success', e => {
                    console.log('复制成功')
                    //  释放内存
                    clipboard.destroy()
                })
                clipboard.on('error', e =>{
                    // 不支持复制
                    console.log('该浏览器不支持复制')
                    // 释放内存
                    clipboard.destroy()
                })
            },
            downlowFun (flag) {
                this.copy()
                fbq('track', 'Purchase', {currency: "USD", value: 1.00});
                if (flag == 'andriod') {
                    this.getDetail(this.bookName, 'click')
                    window.location.href = 'https://play.google.com/store/apps/details?id=com.haiwen.reader'
                } else {
                    this.getDetail(this.bookName, 'click')
                    window.location.href = 'https://apps.apple.com/cn/app/%E5%97%A8%E6%96%87%E5%B0%8F%E8%AA%AA/id1485535288'
                }
            }
        },
    }
</script>
<noscript><img height="1" width="1" style="display:none"
               src="https://www.facebook.com/tr?id=604117387548801&ev=PageView&noscript=1"
/></noscript>
<!-- End Facebook Pixel Code -->
<style scoped lang="scss">
    @import "../../styles/type8";
    *{
        -moz-user-select:none;
        -webkit-user-select:none;
        user-select:none;
    }
    .page{
        display: inline-block;
        width: 100%;
        height: auto;
        background: #fff;
    }
    .page-content{
        max-width: 700px;
        margin:auto;
        padding: 20px;
        p{
            line-height: 1.6;
            margin-bottom: 20px;
            margin: 0 0 10px;
        }
    }
    .rand_pic{
        width: 100%;
    }
    .downloadCon{
        width: 100%;
        text-align: center;
        color: #1f80e3;
        font-size:1.25rem;
        font-weight: bold;
        .name{
            color: #fe3f72;
            font-size: 1.7rem;
        }
        .num{
            color:  #e31f44;
            font-size: 1.65rem;
        }
    }
    .clickImage{
        margin-top: -10px;
        text-align: center;
        img{
            max-width: 100%;
        }
    }
    .center{
        display: inline-block;
        width: 100%;
        margin: auto;
        margin-bottom: 20px;
        .download-btn {
            display: block;
            width: 50%;
            float: left;
            text-align: right;
            img{
                width: 137.6px;
                height: 44.8px;
            }
        }
        .download-btn:last-child{
            text-align: left;
            img{
                margin-left: 20px;
            }
        }
    }
</style>
